import apiClient2 from "@/shared/api/apiClient2";
import apiClientPdf from "@/shared/api/apiClientPdf";

export const getTemplateList = async (params) => {
  try {
    const { data } = await apiClient2.get("/templates/list/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getTemplateList failed", e);
  }
};

export const getTemplateItem = async (code) => {
  try {
    const { data } = await apiClient2.get(`/templates/${code}/`);
    return data;
  } catch (e) {
    console.error("getTemplateItem failed", e);
  }
};

export const createTemplatesForm = async (params) => {
  const result = await apiClient2.post(`/templates/form`, {
    ...params,
  });
  return result.data;
};

export const updateTemplateForm = async (code, params) => {
  const { data } = await apiClient2.put(`/templates/form/${code}`, {
    ...params,
  });
  return data;
};

export const getTemplateGroupedList = async (params) => {
  try {
    const { data } = await apiClient2.get("/templates/list/grouped/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getTemplateGroupedList failed", e);
  }
};

export const uploadDocxToTiptap = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const { data } = await apiClientPdf.post("/upload-docx-to-tiptap", formData, {
    metaData: { isNotificationDisabled: true },
  });
  return data;
};
